<template>
  <div style="margin-top: 8px">
    <el-row v-if="!isDetail && !isRecRet">
      <el-col class="operate-container">
        <el-button size="small" type="primary" class="btn-add" style="margin-left: 24px;margin-top: 0;"
          @click="handleAdd()">
          Add
        </el-button>
      </el-col>
    </el-row>
    <el-col v-if="selectedItems.length != 0">
      <h4 style="color: blue;">{{ selectedItems.length }} item(s) selected</h4>
    </el-col>
    <div class="table-container">
      <el-table ref="pandyTransferItemTable" stripe border :data="itemList" @selection-change="handleSelectionChange"
        :row-class-name="getRowClassName">
        <el-table-column v-if="isRecRet" type="selection" width="50" :selectable="isRowSelectable" />
        <el-table-column label="Photo" width="140" align="center">
          <template #default="scope">
            <img v-if="scope.row.pic" :src="scope.row.pic" alt="Photo" style="width: 45px; height: 45px;" />
          </template>
        </el-table-column>
        <el-table-column label="Product Code" width="140" align="center" fixed>
          <template #default="scope">{{ scope?.row?.refNo }}</template>
        </el-table-column>
        <el-table-column label="Slot Code" width="120" align="center" fixed>
          <template #default="scope">{{ scope?.row?.slotCode }}</template>
        </el-table-column>
        <el-table-column :label="'Is ' + recRet" width="120" align="center">
          <template #default="scope">
            <StatusBadge v-if="scope" :text="isReturnedReceived.fromId(scope.row.isReturnedReceived).name"
              :textColor="isReturnedReceived.fromId(scope.row.isReturnedReceived).textColor"
              :fillColor="isReturnedReceived.fromId(scope.row.isReturnedReceived).fillColor" />
          </template>
        </el-table-column>
        <el-table-column label="Category" width="180" align="center" show-overflow-tooltip>
          <template #default="scope">{{ scope?.row?.categoryName }}</template>
        </el-table-column>
        <el-table-column label="Quality" width="200" align="center" show-overflow-tooltip>
          <template #default="scope">{{ scope?.row?.quality }}</template>
        </el-table-column>
        <el-table-column label="Weight" width="120" align="center">
          <template #default="scope">
            <span v-if="scope">{{ scope.row.wt == 0 ? 0 : scope.row.wtStr + ' ' +
              wtUnitOptions.fromId(scope.row.wtUnit).name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Qty" width="120" align="center">
          <template #default="scope">
            <span v-if="scope">{{ (scope.row.qty == 0 || scope.row.qty == null) ? null : scope.row.qty + '' +
              qtyUnitOptions.fromId(scope.row.qtyUnit).name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Note" width="200" align="center" show-overflow-tooltip>
          <template #default="scope">{{ scope?.row?.note }}</template>
        </el-table-column>
        <el-table-column label="Last Update" width="180" align="center">
          <template #default="scope">{{ formatDateTime(scope?.row?.lastUpdate) }}</template>
        </el-table-column>
        <el-table-column label="Actions" width="120" align="center" fixed="right">
          <template #default="scope">
            <div v-if="scope" style="display:flex;align-items:center;justify-content:center;gap:2px;">
              <RouterLinkButton :disabled="!isDetail"
                :to="{ name: 'itemTransaction', query: { reference: scope.row.ptItemNo } }"
                :cb="() => handleTransaction(scope.$index, scope.row)">
                Transactions
              </RouterLinkButton>
              <span class="action-divider" />
              <el-dropdown trigger="click" @command="(cmd) => handleCommand(scope.$index, scope.row, cmd)">
                <span class="action-trigger" title="Actions">
                  <el-icon :size="15">
                    <MoreFilled />
                  </el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item command="detail" :icon="View">Details</el-dropdown-item>
                    <el-dropdown-item command="history" :icon="Clock" :disabled="!onHistory">History</el-dropdown-item>
                    <el-dropdown-item command="delete" :icon="Delete" divided class="danger-item"
                      :disabled="isDetail || isRecRet">Delete</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { MoreFilled, View, Clock, Delete } from '@element-plus/icons-vue'
import { ofOptions, wtUnitOptions, prUnitOptions, qtyUnitOptions, prFormulaOptions, isReturnedReceived } from '@/utils/constants'
import { formatDateTime } from '@/composables/useFormatters'
import StatusBadge from '@/components/StatusBadge.vue'
import RouterLinkButton from '@/components/RouterLinkButton.vue'

const props = defineProps({
  itemList: { type: Array, default: () => [] },
  isRecRet: { type: Boolean, default: false },
  recRet: { type: String, default: '' },
  isDetail: { type: Boolean, default: false },
  onAdd: { type: Function, default: null },
  onDetail: { type: Function, default: null },
  onHistory: { type: Function, default: null },
  onDelete: { type: Function, default: null },
  onItemTransaction: { type: Function, default: null }
})

const pandyTransferItemTable = ref(null)
const selectedItems = ref([])

function handleAdd() { props.onAdd?.() }
function handleDetail(index, row) { props.onDetail?.(index, row) }
function handleDelete(index, row) { props.onDelete?.(index, row) }
function handleHistory(index, row) { props.onHistory?.(index, row) }
function handleTransaction(index, row) { props.onItemTransaction?.(index, row) }

function handleCommand(index, row, command) {
  if (command === 'detail') handleDetail(index, row)
  else if (command === 'history') handleHistory(index, row)
  else if (command === 'delete') handleDelete(index, row)
}

function isRowSelectable(row) {
  return row.isReturnedReceived === isReturnedReceived.No.id
}

function handleSelectionChange(selection) {
  selectedItems.value = selection
}

function getRowClassName({ row }) {
  if (!props.isRecRet) return ''
  if (row.isReturnedReceived === isReturnedReceived.No.id) return 'row-available'
  return 'row-unavailable'
}

defineExpose({ pandyTransferItemTable, selectedItems })
</script>

<style scoped>
::v-deep(.row-unavailable) {
  background-color: #F5F5F5;
}
</style>
